/**
 * Google maps
 *
 */

if (typeof google !== 'undefined') {
    var markers = [47.3510235,16.2058903]

    var mapOptions = {
        center: new google.maps.LatLng(markers[0], markers[1]),
        zoom: 13,
        styles: [
            {
                "featureType": "administrative",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "saturation": -100
                    },
                    {
                        "lightness": 20
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "saturation": -100
                    },
                    {
                        "lightness": 40
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "on"
                    },
                    {
                        "saturation": -10
                    },
                    {
                        "lightness": 30
                    }
                ]
            },
            {
                "featureType": "landscape.man_made",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "simplified"
                    },
                    {
                        "saturation": -60
                    },
                    {
                        "lightness": 10
                    }
                ]
            },
            {
                "featureType": "landscape.natural",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "simplified"
                    },
                    {
                        "saturation": -60
                    },
                    {
                        "lightness": 60
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    },
                    {
                        "saturation": -100
                    },
                    {
                        "lightness": 60
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    },
                    {
                        "saturation": -100
                    },
                    {
                        "lightness": 60
                    }
                ]
            }
        ]
    };

    if (document.getElementById("map")) {
        var map = new google.maps.Map(document.getElementById("map"), mapOptions);
    }

    //Create and open InfoWindow.
    var infoWindow = new google.maps.InfoWindow();

    var myLatlng = new google.maps.LatLng(markers[0], markers[1]);
    var marker = new google.maps.Marker({
        position: myLatlng,
        map: map,
    });


    //Attach click event to the marker.
    (function (marker) {
        google.maps.event.addListener(marker, "click", function (e) {
            infoWindow.setContent("<div class='contact_infobox'>Bildarchiv Gemeinde Oberschützen</div>");
            infoWindow.open(map, marker);
        });
    })(marker);
}
